import Colors from 'enums/Colors';
import { ResizeMediumWidth } from 'constants/Dimensions';
import styled from 'styled-components';

export const CursoLivreDetailContainer = styled.div<{ highlighted?: boolean }>`
    width: 100%;
    box-sizing: border-box;
    padding: ${props =>
        props.highlighted ? '15px max(20px, calc((100% - 1350px) / 2)) 40px' : '40px max(20px, calc((100% - 1350px) / 2)) 40px'};
    overflow-x: visible;
    overflow-y: visible;

    @media only screen and (max-width: ${ResizeMediumWidth}px) {
        padding: 40px 20px;
    }
`;

export const SectionContainer = styled.div<{ $exclusive?: boolean }>`
    margin-bottom: ${props => (props.$exclusive ? 0 : '64px')};
`;

export const SectionTitle = styled.h2`
    font-family: 'Barlow';
    font-weight: 700;
    font-size: 32px;
    line-height: 1.5;
    color: ${Colors.Blue};
    margin-top: 0;
    margin-bottom: 5px;
    text-align: left;
`;

export const ExclusiveSection = styled.section`
    position: relative;
    width: 100vw;
    margin-left: calc(50% - 50vw);
    margin-right: 0;
    padding: 10px max(20px, calc((100vw - 1350px) / 2)) 0px;

    background-color: #003c78;
    box-sizing: border-box;
    overflow: hidden;

    @media only screen and (max-width: ${ResizeMediumWidth}px) {
        width: 100vw;
        margin-left: calc(50% - 50vw);
        margin-right: 0;
        padding: 48px 20px 56px;
    }
`;

export const ExclusiveSectionContent = styled.div`
    position: relative;
    z-index: 2;
    width: 100%;

    @media only screen and (max-width: 1400px) {
        padding-left: 3%;
    }
`;

export const ExclusiveSectionTitle = styled(SectionTitle)`
    color: #ffffff;
    margin-bottom: 24px;
`;

export const ExclusiveSectionEllipse = styled.img`
    position: absolute;
    right: -110px;
    bottom: -220px;
    width: 400px;
    height: 400px;
    max-width: none;

    z-index: 1;
    pointer-events: none;

    @media only screen and (max-width: ${ResizeMediumWidth}px) {
        right: -80px;
        bottom: -80px;
        width: 280px;
        height: 280px;
    }
`;

export const CardsContainerInner = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: 10px 0;

    @media only screen and (max-width: 912px) {
        justify-content: center;
    }
`;

export const TokenActivationBarWrapper = styled.div`
    width: 100vw;
    margin-left: calc(50% - 50vw);
    margin-right: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;

    @media only screen and (max-width: ${ResizeMediumWidth}px) {
        padding: 0 20px;
    }
`;

export const TokenActivationBar = styled.div`
    width: auto;
    min-height: 56px;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    padding: 12px 24px;

    background-color: #898989;
    border-radius: 42px 0 0 42px;
    box-sizing: border-box;
    gap: 20px;

    @media only screen and (max-width: ${ResizeMediumWidth}px) {
        width: 100%;
        min-height: auto;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        margin: 0 0 20px 0;
        padding: 20px;
        border-radius: 24px;
        gap: 16px;
    }
`;

export const TokenActivationText = styled.p`
    flex: 1;
    margin: 0;
    font-family: 'Barlow';
    font-size: 14px;
    line-height: 26px;
    font-weight: 600;
    color: #ffffff;

    @media only screen and (max-width: ${ResizeMediumWidth}px) {
        width: 100%;
        flex: none;
        text-align: center;
        font-size: 18px;
        line-height: 24px;
    }
`;

export const TokenActivationButton = styled.button`
    flex-shrink: 0;
    min-width: 200px;
    height: 48px;
    padding: 0 28px;

    background-color: ${Colors.Blue};
    color: #ffffff;
    border: none;
    border-radius: 5px;
    font-family: 'Barlow';
    font-size: 18px;
    font-weight: 600;

    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #002f5f;
    }

    @media only screen and (max-width: ${ResizeMediumWidth}px) {
        width: 100%;
        min-width: 0;
        height: 44px;
        padding: 0 18px;
        font-size: 16px;
    }
`;

export const TokenActivationTextContainer = styled.div`
    flex: 1;
    min-width: 0;
    width: 100%;
    display: flex;
    align-items: center;
`;

export const LoginModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;

    background-color: rgba(0, 0, 0, 0.58);
    z-index: 9999;
    box-sizing: border-box;
`;

export const LoginModal = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 521px;
    max-height: 380px;
    padding: 60px 48px;

    background-color: #ffffff;
    border-radius: 5px;
    box-sizing: border-box;

    @media only screen and (max-width: ${ResizeMediumWidth}px) {
        max-width: 355px;
        padding: 40px 30px;
    }
`;

export const CloseModalButton = styled.button`
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;

    border: none;
    background: transparent;
    color: #000000;
    font-family: Arial, sans-serif;
    font-size: 28px;
    font-weight: 400;
    line-height: 1;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
`;

export const LoginModalTitle = styled.h2`
    margin: 0 0 14px;
    font-family: 'Barlow';
    font-size: 32px;

    line-height: 130%;
    font-weight: 600;
    text-align: center;
    letter-spacing: 0.15px;

    color: ${Colors.Blue};
`;

export const LoginModalDescription = styled.p`
    margin: 0 0 14px;
    font-family: 'Roboto';
    font-size: 18px;
    line-height: 150%;
    font-weight: 600;
    text-align: center;

    color: ${Colors.Blue};
`;

export const LoginModalButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 48px;
    padding: 0 16px;
    margin-bottom: 14px;

    background-color: ${Colors.Yellow};
    color: ${Colors.Blue};
    border: none;
    border-radius: 6px;
    font-family: 'Barlow';
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;

    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: ${Colors.Yellow2};
    }
`;

export const CreateAccountText = styled.p`
    margin: 0;
    font-family: 'Barlow';
    font-size: 16px;
    line-height: 18px;
    font-weight: 600;
    text-align: center;

    color: ${Colors.Blue};
`;

export const CreateAccountLink = styled.button`
    padding: 0;
    border: none;
    background: transparent;
    color: #00a8e9;
    font-family: 'Barlow';
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;